<template>
  <div>
    <div class="add-bg"><img :src="require('@/assets/infoPublic/addCardBg.png')" alt="" /></div>
    <div class="add-txt">
      <p class="add-txt-title">班牌录入</p>
      <p class="add-txt-subtitle">请拍摄班牌开机后的二维码，或选择手机相册二维码识别后录入班牌。</p>
      <div class="add-txt-btn">
        <span>拍摄/选择&nbsp;照片</span>
        <input
          ref="referenceUpload"
          type="file"
          name="myPhoto"
          @change="changeFunc($event)"
          id="referenceUpload"
          style="position:absolute;top:0px;left:0px;width:100%;height:100%;opacity:0;"
        />
      </div>
      <div class="add-txt-footer">识别过程受网络影响可能较慢，请您耐心等待。</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "addCard",
  data() {
    return {
      imgFile: {}
    };
  },
  methods: {
    changeFunc(event) {
      let filesUrls = event.target.files[0];
      let imgMasSize = 1024 * 1024 * 10; // 10MB
      // 检查文件类型
      if (["jpeg", "png", "gif", "jpg"].indexOf(filesUrls.type.split("/")[1]) < 0) {
        // 自定义报错方式
        this.xy.msgError("文件类型仅支持 jpeg/png/gif");
        return;
      }
      // 文件大小限制
      if (filesUrls.size > imgMasSize) {
        // 文件大小自定义限制
        this.xy.msgError("文件大小不能超过10MB");
        return;
      }
      //图片压缩
      this.transformFileToDataUrl(filesUrls);
    },
    // 将file转成dataUrl
    transformFileToDataUrl: function(file) {
      let imgCompassMaxSize = 200 * 1024; // 超过 200k 就压缩
      console.log(file.type);
      // 存储文件相关信息
      this.imgFile.type = file.type || "image/jpeg"; // 部分安卓出现获取不到type的情况
      this.imgFile.size = file.size;
      this.imgFile.name = file.name;
      this.imgFile.lastModifiedDate = file.lastModifiedDate;
      // 封装好的函数
      let reader = new FileReader();
      // file转dataUrl是个异步函数，要将代码写在回调里
      reader.onload = e => {
        let result = e.target.result;
        if (result.length < imgCompassMaxSize) {
          this.compress(result, this.processData, false); // 图片不压缩
        } else {
          this.compress(result, this.processData); // 图片压缩
        }
      };
      reader.readAsDataURL(file);
    },
    // 使用canvas绘制图片并压缩
    compress: function(dataURL, callback, shouldCompress = true) {
      let img = new window.Image();
      img.src = dataURL;
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        let compressedDataUrl = "";
        if (shouldCompress) {
          compressedDataUrl = canvas.toDataURL(this.imgFile.type, 0.2);
        } else {
          compressedDataUrl = canvas.toDataURL(this.imgFile.type, 1);
        }
        callback(compressedDataUrl);
      };
    },
    processData: function(dataURL) {
      // 这里使用二进制方式处理dataUrl
      let binaryString = window.atob(dataURL.split(",")[1]);
      let arrayBuffer = new ArrayBuffer(binaryString.length);
      let intArray = new Uint8Array(arrayBuffer);
      let imgFile = this.imgFile;
      for (let i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i);
      }
      let data = [intArray];
      let blob = "",
        blobBuilder = "";
      try {
        blob = new Blob(data, { type: imgFile.type });
      } catch (error) {
        window.BlobBuilder =
          window.BlobBuilder ||
          window.WebKitBlobBuilder ||
          window.MozBlobBuilder ||
          window.MSBlobBuilder;
        blobBuilder = window.BlobBuilder;
        if (error.name === "TypeError" && window.BlobBuilder) {
          let builder = new blobBuilder();
          builder.append(arrayBuffer);
          blob = builder.getBlob(imgFile.type);
        } else {
          // Toast.error("版本过低，不支持上传图片", 2000, undefined, false);
          throw new Error("版本过低，不支持上传图片");
        }
      }
      // blob 转file
      let fileOfBlob = new File([blob], imgFile.name);
      let formData = new FormData();
      // type
      formData.append("type", imgFile.type);
      // size
      formData.append("size", fileOfBlob.size);
      // name
      formData.append("name", imgFile.name);
      // lastModifiedDate
      formData.append("lastModifiedDate", imgFile.lastModifiedDate);
      // append 文件
      formData.append("file", fileOfBlob);
      this.uploadImg(formData);
    },
    async uploadImg(formData) {
      this.xy.loading();
      let postUrl = `${this.$store.state.apiPath}/api/ClassTerminal/QRCodeDiscern`;
      let res = await this.xyapi.post(postUrl, formData);
      if (res.success) {
        this.xy.msgSuc("二维码识别成功");
        this.$store.commit("infoPublic/getCode", res.data.result); //code
        this.$router.push("/home/scanList");
      } else {
        this.$refs.referenceUpload.value = null;
        this.xy.msgError("二维码识别失败");
      }
      this.xy.unloading();
    }
  }
};
</script>
<style lang="less" scoped>
.add-bg {
  width: 100%;
  height: 520px;
  img {
    width: 100%;
    padding: 0px 40px 20px;
  }
}
.add-txt {
  text-align: center;
  p {
    margin-top: 20px;
  }
  .add-txt-title {
    font-size: 34px;
    margin-top: 20px;
  }
  .add-txt-subtitle {
    font-size: 28px;
    padding: 0 40px 20px;
    color: #767676;
    margin-top: 20px;
  }
  .add-txt-btn {
    position: relative;
    background: rgb(86, 121, 242);
    width: 300px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    color: rgb(255, 255, 255);
    font-size: 28px;
    border-radius: 46px;
    margin: 60px auto;
  }
  .add-txt-footer {
    font-size: 24px;
    color: #7f7f7f;
  }
}
</style>
